module.exports = __webpack_public_path__ + "static/media/propic-7.c308af0f.png";